import config from "config/config";
import PlaceAndEducationCrudFilterRestrictModel from "core/sharedmodels/restrictModel/PlaceAndEducationCrudFilterRestrictModel";
import { HttpClientService } from "services/httpClient/httpClientService";
import { ApiResponse } from "../apiResponse";
import PlaceAndEducationCrudFilterRestrictReponseModel from "./reponseModels/forloebCrudFilterRestrictReponseModel";
import PlaceAndEducationCrudFilterRestrictRequestModel from "./requestModels/placeAndEducationCrudFilterRestrictRequestModel";

class StamdataRestrictApi {
    private baseUrl = config.stamdataApiUrl + "api/restrict/";
    private postRestrictForloeboverviewFilterUrl = this.baseUrl + "placeAndEducation/filter";

    constructor(private httpClientService: HttpClientService) {}
    
    async getPlaceAndEducationRestrictions(request: PlaceAndEducationCrudFilterRestrictRequestModel): Promise<PlaceAndEducationCrudFilterRestrictModel> {
        const url = this.postRestrictForloeboverviewFilterUrl;
        const result = await this.httpClientService.Post<ApiResponse<PlaceAndEducationCrudFilterRestrictReponseModel>, PlaceAndEducationCrudFilterRestrictRequestModel>(url, request);
        return result.data;
    }
}

export default StamdataRestrictApi;